<template>
  <div
    id="plan-area"
    class="fill-height"
    style="position: relative; background-color: #4c4c4c"
  >
    <div v-show="planVisible">
      <plan />
    </div>
    <div
      v-if="!planVisible && state === 'in_configuration'"
      class="d-flex justify-center"
      style="padding-top: 300px"
    >
      <input
        ref="fileinput"
        type="file"
        accept=".png,.apng,.jpg,.jpeg,.pdf"
        @change="(e) => handleUpload(e)"
        style="display: none"
      />
      <niko-button
        :text="$t('floorplan.upload')"
        icon-before="$iconUpload"
        @onClick="buttonClicked"
        primary
      />
    </div>
    <v-snackbar :timeout="0" absolute v-model="snackbar" top color="#00AEEF">
      <p>{{ $t("floorplan.instructions") }}</p>

      <v-btn icon @click="() => (snackbar = false)">
        <v-icon>$iconClose</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Plan from "./Plan";
import NikoButton from "../UI/NikoButton";

export default {
  name: "plan-area",
  data: () => ({
    planVisible: false,
    snackbar: false,
  }),
  components: {
    Plan,
    NikoButton,
  },
  methods: {
    ...mapActions("projectStore", ["uploadFloorFile", "deleteFile"]),
    ...mapMutations("loaderStore", ["setIsLoading"]),
    buttonClicked() {
      this.$refs.fileinput.click();
    },
    handleUpload(e) {
      this.setIsLoading(true);
      const file = e.target.files[0];
      if (file.type === "application/pdf") {
        this.handleUploadPdf(file);
      } else {
        this.uploadFloorFile(file);
      }
    },
    async getImageFromPDF(typedarray, fileName) {
      const canvas = document.querySelector("#pdf-canvas");
      const qualityLevel =
        this.fileSize > 50000000
          ? 1
          : this.fileSize > 4000000
          ? 2
          : this.fileSize > 1000000
          ? 3
          : 4;
      // eslint-disable-next-line no-undef
      pdfjsLib.getDocument({ data: typedarray }).promise.then((pdf) => {
        pdf.getPage(1).then((page) => {
          const viewport = page.getViewport(qualityLevel);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          page
            .render({
              canvasContext: canvas.getContext("2d"),
              viewport,
            })
            .promise.then(async () => {
              const res = await fetch(canvas.toDataURL());
              const blob = await res.blob();
              const file = new File([blob], fileName, { type: "image/png" });
              this.uploadFloorFile(file);
            });
        });
      });
    },
    handleUploadPdf(file) {
      const vm = this;
      const fileReader = new FileReader();
      fileReader.onload = function () {
        const typedarray = new Uint8Array(this.result);
        vm.getImageFromPDF(typedarray, file.name);
      };
      fileReader.readAsArrayBuffer(file);
    },
  },
  computed: {
    ...mapState("roomStore", ["isDrawing"]),
    ...mapState("projectStore", ["project_id", "state"]),
    ...mapState("floorStore", ["planURL"]),
  },
  created() {
    this.planVisible = !!this.planURL;
  },
  watch: {
    isDrawing(value) {
      this.snackbar = value;
    },
    planURL(value) {
      this.planVisible = !!value;
    },
  },
};
</script>
